import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const UserManagement = () => {
  return (
    <div>
      <PageTitle title='User Management' role='Risk Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Risk Managers have the ability to edit users in his or her own facility. This can be done by accessing the User Management page. To get to the User Management page, click on the "Administration" tab at the top. After the drop down appears, click on the "Users" option.' />
      <ParaImageDialog src='/tutorial_image/user-management-1.png' />
  
      <ParaTitle paraTitle='Create a New User' />
      <Paragraph paragraph='To create a New User, click on the "Create" icon in the top header bar.' />
      <ParaImageDialog src='/tutorial_image/user-management-2.png' />
      <Paragraph paragraph='A modal will appear and prompt the Risk Manager to fill in the new user&#39;s username, first and last name, and email. Once filled out, the Risk Manager will click on "Create". Immediately after clicking "Create", an email will be sent to the new user containing their temporary password.' />
      <ParaImageDialog src='/tutorial_image/user-management-3.png' />

      <ParaTitle paraTitle='Edit a User' />
      <Paragraph paragraph='To edit another user&#39;s current information, click the "Edit" button in the table. A modal will appear prompting the user to make any changes to the user&#39;s profile. After making the correct modifications, click the "Update" button at the bottom of the modal to save the changes.' />
      <ParaImageDialog src='/tutorial_image/user-management-4.png' />

      <ParaTitle paraTitle='Reset a User&#39;s Password' />
      <Paragraph paragraph='Risk Managers can also reset a user&#39;s password from the User Management page. To reset a password, click the arrow next to the "Edit" button to view additional actions. Listed in the drop down is a "Reset Password" option. Select this option to reset the user&#39;s password.' />
      <ParaImageDialog src='/tutorial_image/user-management-5.png' />

      <ParaTitle paraTitle='Delete a User' />
      <Paragraph paragraph='To delete an existing user, click the arrow next to the "Edit" button to view additional actions. Listed in the drop down is a "Delete" option. Select this option and confirm the action to delete the user.' />
      <ParaImageDialog src='/tutorial_image/user-management-6.png' />

      <Pagination
        pagination={{
          prev: { name: 'Add/View Uploads', link: '/risk-manager/add-view-uploads' },
          next: { name: 'Requesting Approval', link: '/risk-manager/requesting-approval' }
        }}
      />
    </div>
  );
};

export default UserManagement;
